export enum ChatDashboardTab {
  Dashboard = 'dashboard',
  Addressed = 'addressed',
  Scheduled = 'scheduled',
}
